import { IAppState } from '../../store';

export const selectLeadType = (state: IAppState) => state.personalLeadsForm.data.leadType;
